export interface Polyline {
  strokeColor: string;
  strokeWeight: number;
  strokeOpacity: number;
  static: boolean;
  visible: boolean;
  editable: boolean;
  draggable: boolean;
  geodesic: boolean;
  zIndex: number;
}

/* START - INTERFACES FOR BACKEND OBJECTS - START */

export interface RMGenericWebAppResponse {
  status: string;
  flightsCount: number;
  error?: {
    reason: string;
    description: string;
    field: string;
    failureRedirectUrl: string;
  };
}

export interface RMAutoCompleteResponse extends RMGenericWebAppResponse {
  results: RMLocation[];
  language: string;
  pattern: string;
  type: number;
}

export interface RMDestinationsResponse {
  results: RMLocation[];
}

export interface RMMarkerListResponse extends RMGenericWebAppResponse {
  requestDetail: any;
  results: RMMarker[];
}

export interface RMFlightQueryResponse extends RMGenericWebAppResponse {
  requestDetail: any;
  results: RMFlightWrapper[];
  routes: RMRoute[];
  markers: RMMarker[];
  viaPoints: string[];
  miniumResultDate: number;
  maxiumResultDate: number;
}

export interface RMFlightWrapper {
  aircraft: string; // "E7W"
  aircraftName: string; // "Embraer 175 (Enhanced Winglets)"
  airline: string; // "Delta Air Lines"
  arrival: string; // "MSP"
  arrivalCity: string; // "MSP"
  arrivalCityLatLng: RMLatLng;
  arrivalCountry: string; // "USA"
  arrivalCountryCode: string; // "US"
  arrivalDate: number; // 1600245840000
  arrivalDateAsString: string; // "16 September 2020"
  arrivalDayOffset: number; // 0
  arrivalLatLng: RMLatLng;
  arrivalMinuteOfDay: number; // 1333
  arrivalName: string;
  arrivalPortName: string; // "Las Vegas McCarran International Apt"
  arrivalTerminal: string; // "Terminal 1 - Lindbergh"
  arrivalTimeAsString: string; // "09:44 AM"
  availableDatesDeparture: number[];
  availableDatesArrival: number[];
  classesBusiness: string; // "ICZJD"
  classesEconomy: string; // "YKLBQHWOMSNTUEV"
  classesFirst: string; // "PFA"
  codeshareInd: string;
  lowCost: boolean;
  connxLeg1Arrival: string; // "DFW"
  connxLeg1ArrivalCity: string; // "DFW"
  connxLeg1ArrivalCountry: string; // "USA"
  connxLeg1ArrivalCountryCode: string; // "US"
  connxLeg1ArrivalCountryName: string; //
  connxLeg1ArrivalDate: number; // 1602610740000
  connxLeg1ArrivalDateAsString: string; // "13 October 2020"
  connxLeg1ArrivalName: string; // "Dallas"
  connxLeg1ArrivalPortName: string; // "Dallas Dallas/Fort Worth Intl Apt"
  connxLeg1ArrivalState: string; // "Texas"
  connxLeg1ArrivalStateCode: string; // "TX"
  connxLeg1ArrivalTerminal: string; // "Not Pre-Determined"
  connxLeg1ArrivalTimeAsString: string; // "06:39 PM"
  connxLeg2Aircraft: string; // "E75"
  connxLeg2AircraftName: string; // "Embraer 175"
  connxLeg2Airline: string; // "American Airlines"
  connxLeg2Arrival: string; // null;
  // connxLeg2ArrivalCity: null;
  // connxLeg2ArrivalCountry: null;
  // connxLeg2ArrivalCountryCode: null;
  // connxLeg2ArrivalCountryName: null;
  connxLeg2ArrivalDate: number;
  connxLeg2ArrivalDateAsString: string; // null;
  connxLeg2ArrivalName: null;
  connxLeg2ArrivalPortName: string; // null;
  // connxLeg2ArrivalState: null;
  // connxLeg2ArrivalStateCode: null;
  connxLeg2ArrivalTerminal: string; // null;
  connxLeg2ArrivalTimeAsString: string; // null;
  // connxLeg2Classes: null;
  connxLeg2ClassesBusiness: string; // "JDI"
  connxLeg2ClassesEconomy: string; // "YBHKMLVSNQO"
  connxLeg2ClassesFirst: string; //
  connxLeg2CodeshareInd: string;
  connxLeg2Depart: string; // "DFW"
  connxLeg2DepartCity: string; // "DFW"
  connxLeg2DepartCountry: string; // "USA"
  connxLeg2DepartCountryCode: string; // "US"
  connxLeg2DepartCountryName: string; //
  connxLeg2DepartName: string; // "Dallas"
  connxLeg2DepartPortName: string; // "Dallas Dallas\/Fort Worth Intl Apt"
  connxLeg2DepartState: string; // "Texas"
  connxLeg2DepartStateCode: string; // "TX"
  connxLeg2DepartureDate: number; // 1602615600000,
  connxLeg2DepartureDateAsString: string; // "13 October 2020"
  connxLeg2DepartureTerminal: string; // "Not Pre-Determined"
  connxLeg2DepartureTimeAsString: string; // "08:00 PM"
  // connxLeg2EffectiveFrom: null;
  // connxLeg2EffectiveTo: null;
  connxLeg2FlightNo: string; // "3481"
  connxLeg2Frequency: string; //" 234   "
  connxLeg2GreatCircleMiles: number; // 740,
  connxLeg2Kilometres: number; // 1370,
  connxLeg2LowCost: boolean; // false,
  connxLeg2MealsBusiness: RMMealInfo[];
  connxLeg2MealsEconomy: RMMealInfo[];
  connxLeg2MealsFirst: RMMealInfo[];
  connxLeg2OagOpByCarrier: string; // ""
  connxLeg2OagOpByCarrierName: string; // "ENVOY AIR AS AMERICAN EAGLE"
  connxLeg2OagOpByFlightNo: string; // ""
  connxLeg2OperatedBy: string; // "AA"
  connxLeg2SadCarrier: string; // ""
  connxLeg2SadIndicator: string; // "X"
  connxLeg2SadLongName: null;
  connxLeg2SadName: string; // "ENVOY AIR AS AMER"
  connxLeg2StatuteMiles: number; // 851,
  connxLeg2Stops: string; // "0"
  connxLeg2TravelTime: number; // 133,
  connxLeg3Aircraft: string; // "E75"
  connxLeg3AircraftName: string; // "Embraer 175"
  connxLeg3Airline: string; // "American Airlines"
  connxLeg3Arrival: string; // null;
  // connxLeg3ArrivalCity: null;
  // connxLeg3ArrivalCountry: null;
  // connxLeg3ArrivalCountryCode: null;
  // connxLeg3ArrivalCountryName: null;
  connxLeg3ArrivalDate: null;
  // connxLeg3ArrivalDateAsString: null;
  connxLeg3ArrivalName: null;
  connxLeg3ArrivalPortName: string; // null;
  // connxLeg3ArrivalState: null;
  // connxLeg3ArrivalStateCode: null;
  connxLeg3ArrivalTerminal: string; // null;
  connxLeg3ArrivalTimeAsString: string; // null;
  // connxLeg3Classes: null;
  connxLeg3ClassesBusiness: string; // "JDI"
  connxLeg3ClassesEconomy: string; // "YBHKMLVSNQO"
  connxLeg3ClassesFirst: string; //
  connxLeg3CodeshareInd: string;
  connxLeg3Depart: string; // "DFW"
  connxLeg3DepartCity: string; // "DFW"
  connxLeg3DepartCountry: string; // "USA"
  connxLeg3DepartCountryCode: string; // "US"
  connxLeg3DepartCountryName: string; //
  connxLeg3DepartName: string; // "Dallas"
  connxLeg3DepartPortName: string; // "Dallas Dallas\/Fort Worth Intl Apt"
  connxLeg3DepartState: string; // "Texas"
  connxLeg3DepartStateCode: string; // "TX"
  connxLeg3DepartureDate: number; // 1602615600000,
  connxLeg3DepartureDateAsString: string; // "13 October 2020"
  connxLeg3DepartureTerminal: string; // "Not Pre-Determined"
  connxLeg3DepartureTimeAsString: string; // "08:00 PM"
  // connxLeg3EffectiveFrom: null;
  // connxLeg3EffectiveTo: null;
  connxLeg3FlightNo: string; // "3481"
  connxLeg3Frequency: string; //" 234   "
  connxLeg3GreatCircleMiles: number; // 740,
  connxLeg3Kilometres: number; // 1370,
  connxLeg3LowCost: boolean; // false,
  connxLeg3MealsBusiness: RMMealInfo[];
  connxLeg3MealsEconomy: RMMealInfo[];
  connxLeg3MealsFirst: RMMealInfo[];
  connxLeg3OagOpByCarrier: string; // ""
  connxLeg3OagOpByCarrierName: string; // "ENVOY AIR AS AMERICAN EAGLE"
  connxLeg3OagOpByFlightNo: string; // ""
  connxLeg3OperatedBy: string; // "AA"
  connxLeg3SadCarrier: string; // ""
  connxLeg3SadIndicator: string; // "X"
  connxLeg3SadLongName: null;
  connxLeg3SadName: string; // "ENVOY AIR AS AMER"
  connxLeg3StatuteMiles: number; // 851,
  connxLeg3Stops: string; // "0"
  connxLeg3TravelTime: number; // 133,
  depart: string; // "MKE"
  departCity: string; // "MKE"
  departCityLngLat: RMLatLng;
  departCountry: string; // "USA"
  departCountryCode: string; // "US"
  departName: string;
  departPortName: string; // "Milwaukee General Mitchell Intl Apt"
  departureDate: number; // 1600241400000
  departureDateAsString: string; // "16 September 2020"
  departLatLng: RMLatLng;
  departureMinuteOfDay: number; // 830
  departureTerminal: string;
  departureTimeAsString: string; // "08:30 AM"
  effectiveFrom?: number;
  effectiveTo?: number;
  frequency: string;
  flightNo: string; // "3601"
  mealsBusiness: RMMealInfo[];
  mealsEconomy: RMMealInfo[];
  mealsFirst: RMMealInfo[];
  operatedBy: string; // "DL"
  routeKey: string; // "MKE-MSP"
  // TODO: find the difference between totalTravelTime and travelTime
  stops: string; // "0"
  totalTravelTime: number; // 74
  travelTime: number; // 74
  oagOpByCarrier: string; // ""
  oagOpByCarrierName: string; // "ENVOY AIR AS AMERICAN EAGLE"
  oagOpByFlightNo: string; // ""
  sadCarrier: string; // ""
  sadIndicator: string; // "X"
  sdLongName: null;
  sadName: string; // "ENVOY AIR AS AMER"
}

export interface RMRoute {
  points: RMRoutePoint[];
  key: string;
}

export interface RMRoutePoint {
  latLng: RMLatLng;
  code: string;
}

export interface RMLatLng {
  lat: number;
  lng: number;
  type: number;
}

export interface RMMarker {
  code: string;
  name: string;
  type: number; // 0 airport; 1 city.
  latLng: RMLatLng;
  portName: string;
  metroName?: string;
  countryCode?: string;
  countryName?: string;
  location: RMLocation;
}

export interface RMDestination {
  location: RMLocation;
}

export interface RMLocationElement {
  code: string;
  latLng: RMLatLng;
  portType: number;
  translations: { [key: string]: string };
  type: string;
}

export interface RMLocation {
  language: string;
  readOnly: boolean;
  tag: number;
  uniqueId: string;
  city: RMLocationElement;
  country: RMLocationElement;
  port: RMLocationElement;
  searchString: string;
  state: RMLocationElement;
  subCountry: RMLocationElement;
}

export interface RMMealInfo {
  code: string;
  name: string;
}

/* END - INTERFACES FOR BACKEND OBJECTS - END */

export interface AppConfig {
  title: string; // "Route Mapper",
  cssPath: string;
  disableGATracking: boolean;
  language: string;
  version: number; // 0.1;
  customerId?: string; // "MKEAirport",
  toolId?: string;
  serviceServer?: string;
  serviceRoute?: string;
  customerValidateFailureUrl: string; // "http://www.oag.com",
  cssVersion: string; // "app",
  validationType: null;
  lfMain?: string; // 'MTT12',//choose folder main+{N10,ITT10,MOT11,MOB11}
  lfForm?: string; // 'N10',//choose folder form+{N10,ITT10}
  lfTabs?: string; // 'N10',//choose folder tabs+{N10,ITT10}
  lfResHead?: string; // 'N11',//choose folder resHead+{N10,ITT10,N11}
  lfResults?: string; // 'N11',//choose folder results+{N10,ITT10,N11,W11}
  gaCustomConfig?:
    | {
        id: string;
        pathBase?: string;
      }
    | {
        id: string;
        pathBase?: string;
      }[];
  layout: string; // "flightfinder",
  customerType: {
    airline: boolean; // true;
    airport: boolean; // false;
    airlineVersion: {
      single: boolean; // false;
      multi: boolean; // true;
      alliance: boolean; // false;
      airline: string;
    };
    airportVersion: {
      single: boolean; // false;
      multi: boolean; // false;
      airport: string;
      airports: string[];
    };
  };
  analytics: {
    google: {
      ga: string; // "UA-59938408-1"
    };
  };
  airportsFilter: string[];
  airportsFilterOut: string[];
  airportMarkerFilter: boolean;
  urls: {
    directMarkers: string; // "ConnectionBuilder/DirectMarkers.ashx", //'connection-builder/direct-markers',
    directMarkersAirport: string; // "ConnectionBuilder/DirectMarkersAirport.ashx",
    connectionMarkersAirport: string; // "ConnectionBuilder/ConnectionMarkersAirport.ashx",
    connnectionBuilderDirects: string; // "ConnectionBuilder/Directs.ashx",
    connectionBuilderConnections: string; // "ConnectionBuilder/Connections.ashx",
    validate: string; // "ApplicationCustomer/Validate.ashx",
    findAirportBoundsViewportIataPattern: string; // "GoogleGeocoder/FindAirportBoundsViewportIataPattern.ashx",
    findAirportBoundsViewport: string; // "GoogleGeocoder/FindAirportBoundsViewport.ashx",
    capaValidation: string; // "Capa/Validate.ashx",
    preferredAirline: string; // "ConnectionBuilder/PreferredAirlines.ashx",
    automcomplete: string; // "Autocomplete.ashx",
  };
}

export interface AppComponents {
  dateFormat: string; // "dd MMMM yyyy",
  timeFormat: string; //  "h:mm a",
  Container: {
    cssClasses: string; //  "container-fluid",
  };
  Map: {
    display: boolean; // true;
    style: string; //  "background-color:#B2D0FE;",
    cssClasses: string; //  "col-sx-12 col-sm-9 col-md-9",
    Debug: {
      visible: boolean; // true;
    };
  };
  SearchAndResults: {
    display: boolean; // true;
    cssClasses: string; //  "col-sx-12 col-sm-3 col-md-3",
    cssClasses_wide: string; //  "col-sx-12 col-sm-12 col-md-12",
  };
  FormTopTabs: TabInfo[];
  Headers: {
    Flight: {
      Direct: {
        display: boolean; // true;
      };
      Connection: {
        display: boolean; // true;
      };
      Date: {
        display: boolean; // true;
      };
    };
    FlightSearchFilter: {
      display: boolean; // true;
    };
  };
  Images: {
    HeaderLogo: {
      display: boolean; // false;
      link: string; //  "",
      target: string; //  "",
    };
    OAGPromoLogo: {
      display: boolean; // false;
      link: string; //  "",
      target: string; //  "",
    };
  };
  Tabs: {
    whereWeFly: {
      display: boolean; // true;
    };
    flightFinder: {
      display: boolean; // true;
    };
  };
  Inputs: {
    OriginIata: {
      display: boolean; // true;
    };
    DestinationIata: {
      display: boolean; // true;
      anywhere: boolean;
    };
    RequestDate: {
      display: boolean; // true;
      startingDay: 1;
      initDayOffset: number;
      init?: boolean; // true
      pastDate?: boolean;
    };
    RequestTime: {
      display: boolean; // true;
      format: "full" | "dropdown"; //  "full",
      adjustment: number; // 0;
    };
    DateRange: {
      display: boolean; // false;
    };
    NonStopFlights: {
      display: boolean; // true;
      value: boolean; // false;
      checked: boolean; // false;
      format: "single" | "multi";
    };
    IncludeConnections: {
      display: boolean; // true;
    };
    ReturnRequestDate: {
      display: boolean; // true;
      startingDay: number; // 1;
      initDayOffset: number;
      init?: boolean; // true
      pastDate?: boolean;
    };
    ReturnRequestTime: {
      display: boolean; // true;
      format: string; //  "full",
      adjustment: number; // 0;
    };
    CarrierMultiSelect: {
      display: boolean; // true;
    };
    PreferredAirlineSelect: {
      display: boolean; // false;
    };
    IncludeCodeShare: {
      display: boolean; // true;
      format: string; //  "single",
      checked: boolean; // true;
    };
    DateRangeWeekly: {
      display: boolean; // false;
      weeklyDefault: boolean; // false;
    };
    RoundTrip: {
      display: boolean; // false;
      onewayDefault: boolean; // false;
    };
    TimeFormat: {
      display: boolean;
    };
  };
  Buttons: {
    DirectSearch: {
      display: boolean; // true;
      label: string; //  "Fetch",
    };
    ClearAll: {
      display: boolean; // true;
    };
  };
  Windows: {
    ParametersDebug: {
      display: boolean; // false;
    };
    MapDirectConnectingLegend: {
      display: boolean; // true;
    };
  };
  SearchPanel: {
    HeaderStrap: {
      display: boolean; // true;
      translation: string; //  "HEADER_FLIGHT_FINDER",
    };
    LanguageToggle?: {
      display: boolean;
    };
  };
  Print: {
    whereWeFly: {
      display: boolean; // true;
    };
    flightFinder: {
      display: boolean; // true;
    };
  };
  Results: {
    format: "ITT" | "flight-finder" | "mapper"; //  "mapper",
    gridHeadDateFormat: string[];
    copyToClipboard: false;
    whereWeFly: {
      outbound: {
        directs: {
          display: boolean; // true;
        };
        connections: {
          display: boolean; // true;
        };
      };
    };
    return: {
      directs: {
        display: boolean; // true;
      };
      connections: {
        display: boolean; // true;
      };
    };
    flightFinder: {
      tabs: {
        outbound: {
          directs: {
            display: boolean; // true;
          };
          connections: {
            display: boolean; // true;
          };
        };
        returns: {
          directs: {
            display: boolean; // true;
          };
          connections: {
            display: boolean; // true;
          };
        };
        oneSubTab: {
          display: boolean;
        };
      };
      outbound: {
        directs: {
          display: boolean; // true;
        };
        connections: {
          display: boolean; // true;
        };
      };
      return: {
        directs: {
          display: boolean; // true;
        };
        connections: {
          display: boolean; // true;
        };
      };
      headers: {
        departureTime: {
          display: boolean; // false;
        };
      };
    };
    showFlightStatusInPopup: boolean;
    enableAirlineLink: boolean;
    showFirstClass: boolean;
    mergeFlightResults: boolean;
    translateSeatClass?: string;
    translateSeatClassNew?: string;
  };
  FilterAndSortMenus: {
    airline: boolean; // true;
    timespan: boolean; // true;
    via: boolean; // true;
    stops: boolean; // true;
    filterWarning: boolean; // false;
    timesort: boolean; // true;
    sortDefault:
      | "departureMinuteOfDay"
      | "arrivalMinuteOfDay"
      | "totalTravelTime";
  };
  Errors: {
    NO_FLIGHTS_FOUND_SUMMARY: string; //  "LABEL_NO_FLIGHTS_FOUND",
    NO_FLIGHTS_FOUND_DETAIL: string; //  "LABEL_NO_FLIGHTS_FOUND_DETAIL",
    NO_NONSTOP_FLIGHTS_FOUND_SUMMARY: string; //  "LABEL_NO_NONSTOP_FLIGHTS_FOUND",
    NO_NONSTOP_FLIGHTS_FOUND_DETAIL: string; //  "LABEL_NO_NONSTOP_FLIGHTS_FOUND_DETAIL",
  };
  Validation?: {
    roundTripDateRangeRestriction?: {
      enabled: boolean;
      splitDate: string | null; // ISO date "yyyy-MM-dd", e.g. "2026-05-19"
      errorKey: string;
    };
  };
  ShowOAGCopyright: boolean;
}

export interface CbwsRequest {
  atcPercentageRouting: null;
  bothWays: null;
  carrier1Criteria: string; // "***",
  carrier2Criteria: string; // "***",
  carrier3Criteria: string; // null,
  destinationCriteria: string; // "***",
  destinationCriteriaLocationType: string; // "A",
  enableOnline: boolean; // false;
  interAirportConnections: boolean; // false;
  logicalPathOnly: string | null; // "D";
  lowCostConnectionsIndicator: null;
  maxCT1: number; // 400,
  maxCT2: number; // null,
  maxCircuity: number; // 180,
  maxDoublesRoute: null;
  maxElapsedTime: number; // 2400,
  maxSinglesRoute: number; // 5000;
  originCriteria: string; // "***";
  originCriteriaLocationType: string; // "A",
  overrideMinCT1: null;
  overrideMinCT2: null;
  requestDate: string; // null;
  requestDateEffectiveFrom: string; // null;
  requestDateEffectiveTo: string; // null;
  requestTime: string; // "00:00:01",
  rtnRequestDate: string; // null;
  rtnRequestTime: string; // null;
  sortOrder: string; // "D",
  useForwardRoutes: null;
  via1Criteria: string; // "***",
  via1CriteriaLocationType: string; // "A",
  via2Criteria: string; // "", //populate for double connections
  via2CriteriaLocationType: string; // "A",
  preferredCarrierCriteria: string;
  excludeCarrierCriteria: string;
  mcConnectionsIndicator: null;
  transportTypeIndicator: null;
  operatingCarrierOnly: boolean; // false;
  nonOperatingCarrierOnly: null;
  mctProductOverrideId: null;
  extraLocationFilter: null;
  includeFreighter: null;
  includeRoadFeederService: null;
  wideToNarrowIndicator: null;
  cargoCarrierDupePriority: null;
  backHaulIndicator: null;
  leg1ServiceNumber: null;
  leg2ServiceNumber: null;
  leg3ServiceNumber: null;
  conciseFormatForConxAlerts: null;
  maxSingleCnxPerRoute: null;
  maxDoubleCnxPerRoute: null;
  notEditable: null;
  equipmentType: null;
  equipmentCategoryCode: null;
  dbWrite: null;
  overrideMinCT1DDDIIDII: null;
  overrideMinCT2DDDIIDII: null;
  overrideMaxCT1DDDIIDII: null;
  overrideMaxCT2DDDIIDII: null;
  applyPhantomFlights: null;
  interlineType: null;
  specificPhantomFlightIds: null;
  userId: null;
  numberOfStops: number; // 0;
  stopsLtGtEq: null;
  missedCnxMCTTolerance: null;
  missedCnxMaxCTTolerance: null;
  checkMissedConnections: null;
  applyQSI: null;
  allowRestrictedFlights: null;
  internationalOrDomestic: null;
  multiConnectionRequest: null;
  timeSeries: null;
  periodType: null;
  includeRoutes: boolean; // true;
  includeResults: boolean; // true;
  includeMarkers: boolean; // true;
  requestType: string; // null;
  language: string; // "EN",
  description: string; // "",
  includeCodeShare: boolean; // true;
  nonStopDirect: boolean; // false;
  dateFormat: string;
  timeFormat: string;
  configurationKey: null;
  maxResults: null;
}

export interface MapperCustom {
  markerPadding: number[]; // [0.12, 0.11, 0.11, 0.03];
  includeBookingLink: boolean; // false,
  bookingLink: {
    url: string; // "//www.kiwi.com/en/search/results/%DepartureAirportCode%/%ArrivalAirportCode%/%SchedDepartureLocalDate%/%SchedReturnLocalDate%/";
    urlNew?: string;
    summaryLegUrl: string; // "//www.kiwi.com/en/search/results/%DepartureAirportCode%/%ArrivalAirportCode%/%SchedDepartureLocalDate%/%SchedReturnLocalDate%/";
    detailLegUrl: string; // "//www.kiwi.com/en/search/results/%DepartureAirportCode%/%ArrivalAirportCode%/%SchedDepartureLocalDate%/%SchedReturnLocalDate%/";
    formUrl: string; // "//www.kiwi.com/en/search/results/%DepartureAirportCode%/%ArrivalAirportCode%/%SchedDepartureLocalDate%/%SchedReturnLocalDate%/";
    transitionDate?: string;
    transitionDateOverride?: string | null;
    newSiteDateFormat?: string;
    formats: {
      dateFormat: string; // "yyyy-MM-dd";
    };
    target: string; // "_blank";
  };
  includeAirlineLinks: boolean; // true,
  mode: number; // 0;
  homeIconOverride: null;
  originIconOverride: null;
  oppositeIconOverride: null;
  directIconOverride: null;
  connectionIconOverride: null;
  startUpPoints: [];
  startUpPointsConnections: [];
  selectedDirectMarkers: [];
  selectedConnectionMarkers: [];
  originPort: string; // "MKE";
  nonStopDirectMap: boolean; // false,
  stopsAreConnections: boolean; // true,
  intialiseStartUpPoints: {
    directs: boolean; // true,
    connections: boolean; // true,
    autoZoomMode: string; // "fixed";
    panToAirport: boolean; // true
    daysToLookForward: number;
  };
  openWithFocusOnWhereWeFlyTo: boolean; // false,
  showStarBurst: boolean; // true;
  lockOrigin: boolean; // true;
  lockDestination: boolean; // false;
  allowSameDestination?: boolean; //true
  showVia: boolean; // true;
  enableLowCostIndicator: boolean; // false;
  displayDateFormat: string; // "hh:mm tt";
  flightFinder: {
    directs: {
      enable: boolean; // true;
      carrier1Criteria: string; // "***";
      carrier2Criteria: string; // "***";
      carrier3Criteria: string; // null;
      prefferedCarrier: null;
      preferredCarrierCriteria: null;
      originCriteria: null;
      destinationCriteria: null;
      viaCriteria: null;
    };
    connections: {
      enable: boolean; // true;
      carrier1Criteria: string; // "***";
      carrier2Criteria: string; // "***";
      carrier3Criteria: string; // null;
      prefferedCarrier: null;
      preferredCarrierCriteria: null;
      originCriteria: null;
      destinationCriteria: null;
      viaCriteria: null;
    };
    details: {
      enable: boolean; // true;
    };
  };
  showPolyLines: boolean; // true;
  directIconStyle?: {
    "circle-radius": number;
    "circle-color": string;
    "circle-stroke-color": string;
    "circle-stroke-width": number;
  };
  connectionIconStyle?: {
    "circle-radius": number;
    "circle-color": string;
    "circle-stroke-color": string;
    "circle-stroke-width": number;
  };
  homeIconStyle?: {
    "circle-radius": number;
    "circle-color": string;
    "circle-stroke-color": string;
    "circle-stroke-width": number;
  };
  polyLineDefaults: Polyline;
  polyLineConnectionDefaults: Polyline;
  callouts: {
    format: string[]; // ["%CODE% - %PORT%", "%CITY%"];
    enableAlwaysOn: boolean; // false;
  };
  autocomplete: {
    searchType: number; // 4;
    filter: {
      carrier: null;
      port: null;
    };
    initOriginAutoComplete: boolean; // true;
    initDestinationAutoComplete: boolean; // false;
  };
  ajaxStatus: {
    started: number; // 0;
    completed: number; // 1;
  };
  require: {
    carrier: boolean; // false;
    from: boolean; // true;
    to: boolean; // true;
  };
}

export interface MapConfiguration {
  mapFramework: string; // RMConst.Map.MapFramework.LEAFLET;
  tileSource: {
    id: string; // 'MAPBOX',
    url: string; // 'https://api.mapbox.com/styles/v1/oagmaps/cjvibnbw8069a1cq49o47r1eg/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoib2FnbWFwcyIsImEiOiJjamdvMXY0cjMxYnQwMndybTE2aDB4OWgyIn0.FbAieWEp4uuSrRLw-GAAsg',
  };
  tileSourceUrl: null;
  legend: {
    display: boolean; // true;
    position: string; // RMConst.Position.RIGHT_TOP;
  };
  zoomControl: {
    display: boolean; // true;
    position: string; // RMConst.Position.RIGHT_TOP;
  };
  scaleControl: {
    display: boolean; // true;
    position: string; // RMConst.Position.RIGHT_BOTTOM;
  };
  zoom: number; // 2;
  showTraffic: boolean; // false;
  showBicycling: boolean; // false;
  showWeather: boolean; // false;
  showHeat: boolean; // false;
  minZoom: number; // 2;
  maxZoom: number; // 12;
  mapTypeControl: boolean; // false;
  scrollwheel: boolean; // true;
  streetViewControl: boolean; // false;
  panControl: boolean; // false;
  center: {
    lat: number; // 51.4706;
    lng: number; // -0.461941
  };
  startupSpan: number; // 360;
  styles: any[];
}

export interface PopUpMapConfiguration {
  mapFramework: string; // RMConst.Map.MapFramework.LEAFLET;
  tileSourceUrl: null;
  legend: {
    display: boolean; // false;
    position: null;
  };
  zoomControl: {
    display: boolean; // true;
    position: string; // RMConst.Position.RIGHT_TOP;
  };
  scaleControl: {
    display: boolean; // false;
    position: string; // RMConst.Position.RIGHT_BOTTOM;
  };
  zoom: number; // 20;
  showTraffic: boolean; // false;
  showBicycling: boolean; // false;
  showWeather: boolean; // false;
  showHeat: boolean; // false;
  mapTypeControl: boolean; // false;
  scrollwheel: boolean; // true;
  streetViewControl: boolean; // false;
  panControl: boolean; // false;
  center: {
    lat: number; // 51.4706;
    lng: number; // -0.461941
  };
}

export interface Mapper {
  includeBookingLink: boolean; // false;
  bookingLink: {
    url: string;
    urlDomestic: string;
    urlIntl: string;
    urlNew?: string;
    domesticCountryCode: string;
    transitionDate?: string;
    transitionDateOverride?: string | null;
    newSiteDateFormat?: string;
    parameters: object; // {};
    formats: {
      dateFormat: string;
      departureDateFormat: string;
      departureTimeFormat: string;
      arrivalDateFormat: string;
      arrivalTimeFormat: string;
    };
    summaryLegUrl: string;
    detailLegUrl: string;
    target: null;
  };
  includeAirlineLinks: boolean; // false;
  validationType: null;
  defaultIcon: object; // defaultIcon;
  defaultHomeIcon: object; // defaultHomeIcon;
  defaultOriginIcon: object; // defaultOriginIcon;
  defaultOppositeIcon: object; // defaultOppositeIcon;
  defaultDirectIcon: object; // defaultDirectIcon;
  defaultConnectionIcon: object; // defaultConnectionIcon;
  getHomeIcon: () => any;
  getOriginIcon: () => any;
  getOppositeIcon: () => any;
  getDirectIcon: () => any;
  //getDirectIcon:function(){ var ret = this._getDirectIcon() ; console.log( "directI:%o", ret ) ; return ret ; },
  getConnectionIcon: () => any;
  startUpPoints: [];
  startUpPointsConnections: [];
  selectedDirectMarkers: [];
  selectedConnectionMarkers: [];
  originPort: string; // "***";
  nonStopDirectMap: boolean; // false;
  stopsAreConnections: boolean;
  intialiseStartUpPoints: {
    directs: boolean; // true;
    connections: boolean; // true;
    autoZoomMode: string; // "connections";
    daysToLookForward: number; // 7;
    panToAirport: boolean;
  };
  openWithFocusOnWhereWeFlyTo: boolean; // false;
  showStarBurst: boolean; // true;
  lockOrigin: boolean; // false;
  lockDestination: boolean;
  allowSameDestination?: boolean; //true
  showVia: boolean;
  lockFormViaDirection: boolean;
  enableLowCostIndicator: boolean; // false;
  displayDateFormat: string; // "HH:mm";
  codeShareCarrierList: string; // "";
  flightFinder: {
    directs: {
      enable: boolean; // true;
      carrier1Criteria: string;
      carrier2Criteria: string;
      carrier3Criteria: null;
      prefferedCarrier: string;
      preferredCarrierCriteria: string;
      originCriteria: null;
      destinationCriteria: null;
      viaCriteria: null;
    };
    connections: {
      enable: boolean; // true;
      carrier1Criteria: string;
      carrier2Criteria: string;
      carrier3Criteria: null;
      prefferedCarrier: string;
      preferredCarrierCriteria: string;
      originCriteria: null;
      destinationCriteria: null;
      viaCriteria: null;
    };
    details: {
      enable: boolean; // true;
    };
  };
  showPolyLines: boolean; // true;
  directIconStyle: {
    "circle-radius": number;
    "circle-color": string;
    "circle-stroke-color": string;
    "circle-stroke-width": number;
  };
  connectionIconStyle: {
    "circle-radius": number;
    "circle-color": string;
    "circle-stroke-color": string;
    "circle-stroke-width": number;
  };
  homeIconStyle: {
    "circle-radius": number;
    "circle-color": string;
    "circle-stroke-color": string;
    "circle-stroke-width": number;
  };
  polyLineDefaults: Polyline;
  polyLineConnectionDefaults: Polyline;
  autocomplete: {
    searchType: number; // 4;
    filter: {
      carrier: null;
      port: null;
    };
    initOriginAutoComplete: boolean; // false;
    initDestinationAutoComplete: boolean; // false;
  };
  ajaxStatus: {
    started: number; // 0;
    completed: number; // 1;
  };
  require: {
    carrier: boolean; // true;
    from: boolean; // true;
    to: boolean; // true;
  };
  carriersList: [];
  getCarriersList: () => any;
  getCarriersCommaDelimitedList: () => any;
  googlIconConfigFor: (string) => any;
  googlize: () => any;
  enableFlightTypeToggle?: boolean; // false; - Enable direct/connection flight type toggle filter
}

export interface DirectRequest {
  atcPercentageRouting?: any;
  bothWays?: any;
  carrier1Criteria: string; // "***"
  carrier2Criteria: string; // "***"
  carrier3Criteria?: any;
  destinationCriteria: string; // "MSP"
  destinationCriteriaLocationType: string; // "A"
  enableOnline: boolean; // false
  interAirportConnections: boolean; // false
  logicalPathOnly?: any;
  lowCostConnectionsIndicator: string; // "B"
  maxCT1: number; // 400
  maxCT2?: any;
  maxCircuity: number; // 200
  maxDoublesRoute?: any;
  maxElapsedTime: number; // 2400
  maxSinglesRoute?: any;
  originCriteria: string; // "MKE"
  originCriteriaLocationType: string; // "A"
  overrideMinCT1?: any;
  overrideMinCT2?: any;
  requestDate: string; // "2020-09-16"
  requestDateEffectiveFrom?: any;
  requestDateEffectiveTo?: any;
  requestTime: string; // "00:01:00"
  rtnRequestDate: string; // "2020-09-22"
  rtnRequestTime: string; // "00:01:00"
  sortOrder: string; // "D"
  useForwardRoutes?: any;
  via1Criteria: string; // "***"
  via1CriteriaLocationType: string; // "A"
  via2Criteria: string; // ""
  via2CriteriaLocationType: string; // "A"
  preferredCarrierCriteria?: any;
  excludeCarrierCriteria?: any;
  mcConnectionsIndicator?: any;
  transportTypeIndicator?: any;
  operatingCarrierOnly: boolean; // false
  nonOperatingCarrierOnly?: any;
  mctProductOverrideId?: any;
  extraLocationFilter?: any;
  includeFreighter?: any;
  includeRoadFeederService?: any;
  wideToNarrowIndicator?: any;
  cargoCarrierDupePriority?: any;
  backHaulIndicator?: any;
  leg1ServiceNumber?: any;
  leg2ServiceNumber?: any;
  leg3ServiceNumber?: any;
  conciseFormatForConxAlerts?: any;
  maxSingleCnxPerRoute?: any;
  maxDoubleCnxPerRoute?: any;
  notEditable?: any;
  equipmentType?: any;
  equipmentCategoryCode?: any;
  dbWrite?: any;
  overrideMinCT1DDDIIDII?: any;
  overrideMinCT2DDDIIDII?: any;
  overrideMaxCT1DDDIIDII?: any;
  overrideMaxCT2DDDIIDII?: any;
  applyPhantomFlights?: any;
  interlineType?: any;
  specificPhantomFlightIds?: any;
  userId?: any;
  numberOfStops?: any;
  stopsLtGtEq?: any;
  missedCnxMCTTolerance?: any;
  missedCnxMaxCTTolerance?: any;
  checkMissedConnections?: any;
  applyQSI?: any;
  allowRestrictedFlights?: any;
  internationalOrDomestic?: any;
  multiConnectionRequest?: any;
  timeSeries?: any;
  periodType?: any;
  maxResults?: any;
  includeRoutes: boolean; // true
  includeResults: boolean; // true
  includeMarkers: boolean; // true
  requestType?: any;
  language: string; // "en-mkeairport";
  description: string; // "outbound-directs";
  includeCodeShare: boolean; // false
  nonStopDirect: boolean; // false
  dateFormat?: any;
  timeFormat: string; // "hh:mm tt"
  configurationKey: string; // "MKEAirport";
}

export interface DirectFlightsRequest extends DirectRequest {
  originCriteriaLocationtype: string; // "A";
}

export interface AirportOption {
  code: string;
  label: string;
}

export interface SearchFlightsForm {
  direction: "from" | "to" | "via";
  originAirport: RMLocation;
  destinationAirport: RMLocation;
  destinationAnywhere: boolean;
  viaAirport: RMLocation;
  departingDateFrom: number;
  departingDate: number;
  departingDateTo: number;
  departingTime: string;
  departingTimeSelect: TimeSelect;
  returningDateFrom: number;
  returningDate: number;
  returningDateTo: number;
  returningTime: string;
  returningTimeSelect: TimeSelect;
  nonStopFlights: boolean;
  dateRange: boolean;
  dateRangeWeekly: boolean;
  roundTrip: boolean;
  codeShares: boolean;
  disabled: boolean;
  includeCodeShare: boolean;
  flightType: FlightTypeSelect;
}

export enum TimeSelect {
  AnyTime = "ANY_TIME",
  Morning = "MORNING",
  Afternoon = "AFTERNOON",
  Evening = "EVENING",
}

export enum DirectionTypes {
  None = "",
  Outbound = "outbound",
  Return = "return",
}

export interface FlightDetails {
  airline: string;
  operatedBy: string;
  flightNo: string;
  departureDate: number;
  departureDateAsString: string;
  departureTimeAsString: string;
  arrivalDate: number;
  arrivalDateAsString: string;
  arrivalTimeAsString: string;
  travelTime: number;
  depart: string;
  departPortName: string;
  departName: string;
  departureTerminal: string;
  arrival: string;
  arrivalPortName: string;
  arrivalName: string;
  arrivalTerminal: string;
  classFirst: string;
  classBusiness: string;
  classEconomy: string;
  mealsFirst: RMMealInfo[];
  mealsBusiness: RMMealInfo[];
  mealsEconomy: RMMealInfo[];
  aircraftName: string;
  oagOpByCarrier: string;
  oagOpByFlightNo: string;
  sadName: string;
  frequency: string;
  effectiveFrom: number;
  effectiveTo: number;
}

export enum FlightTypeSelect {
  NonStop = "NON_STOP",
  Connecting = "CONNECTING",
  All = "ALL",
}

export interface TabInfo {
  code: string;
  label: string;
}
